import { HttpInterceptor, HttpClient, HttpBackend, HttpHandler, HttpEvent, HttpRequest } from "@angular/common/http";
import { InjectionToken, Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";

export const AUTH_HTTP_INTERCEPTORS = new InjectionToken<HttpInterceptor[]>("An abstraction on auth HttpInterceptor[]");

@Injectable()
export class AuthHttpClient extends HttpClient {
  constructor(backend: HttpBackend, @Inject(AUTH_HTTP_INTERCEPTORS) authInterceptors: HttpInterceptor[]) {
    super(new InterceptingHandler(backend, [authInterceptors].flat()));
  }
}

class InterceptingHandler implements HttpHandler {
  private chain!: HttpHandler;

  constructor(
    private backend: HttpBackend,
    private interceptors: HttpInterceptor[]
  ) {
    this.buildChain();
  }

  handle(req: HttpRequest<unknown>): Observable<HttpEvent<unknown>> {
    return this.chain.handle(req);
  }

  private buildChain(): void {
    this.chain = this.interceptors.reduceRight(
      (next, interceptor) => new InterceptorHandler(next, interceptor),
      this.backend
    );
  }
}

class InterceptorHandler implements HttpHandler {
  constructor(
    private next: HttpHandler,
    private interceptor: HttpInterceptor
  ) {}

  handle(req: HttpRequest<unknown>): Observable<HttpEvent<unknown>> {
    return this.interceptor.intercept(req, this.next);
  }
}
